<template>
  <!-- Logout Component -->
  <v-container>
    <v-row align="center" justify="center" width="800">
      <v-col cols="12" xl="6" lg="6" md="6" sm="12">
        <v-card color="primary">
          <v-card-title>
           {{ get("header-1") }}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn outlined @click="onLogout">{{ get("b-1") }}</v-btn>
              <v-spacer></v-spacer>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import router from "@/router";
import localizationMixin from "@/mixins/localization-mixin";
import { Status } from "@/constants";
import store from "@/store";

export default {
  name: "Account-Logout",

  components: {
  },

  created() {
    this.pageName = "log-out";
  },

  mixins: [localizationMixin],
  methods: {
    getLocalization(){},
    onLogout() {
      const notification = {
        title: "Logout",
        status: Status.success,
        messages: ["User logged out"],
      };
      store.commit("setNotification", notification);
      const user = {
            id: 0,
            email: '',
            expires: '',
            LoggedIn: false,
            firstname: '',
            lastname: '',
            lastLogin: '',
            token: '',
        }
        this.userId = 0
        store.commit("setUser", user);
        store.commit("updateMenu");

      router.push("/");
    },
  },

  router,
  store,
};
</script>
<style lang="scss" scoped>
.v-card {
  margin-right: 15px;
}
.v-btn {
  margin-bottom: 20px;
  margin-left: 10px;
}
</style>
